// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface SimulateRainfallStandardEventsOutput
 */
export interface SimulateRainfallStandardEventsOutput {
  /**
   *
   */
  results: RanaFile;
}

/**
 * Check if a given object implements the SimulateRainfallStandardEventsOutput interface.
 */
export function instanceOfSimulateRainfallStandardEventsOutput(
  value: object
): value is SimulateRainfallStandardEventsOutput {
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function SimulateRainfallStandardEventsOutputFromJSON(
  json: any
): SimulateRainfallStandardEventsOutput {
  return SimulateRainfallStandardEventsOutputFromJSONTyped(json, false);
}

export function SimulateRainfallStandardEventsOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulateRainfallStandardEventsOutput {
  if (json == null) {
    return json;
  }
  return {
    results: RanaFileFromJSON(json["results"]),
  };
}

export function SimulateRainfallStandardEventsOutputToJSON(
  json: any
): SimulateRainfallStandardEventsOutput {
  return SimulateRainfallStandardEventsOutputToJSONTyped(json, false);
}

export function SimulateRainfallStandardEventsOutputToJSONTyped(
  value?: SimulateRainfallStandardEventsOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    results: RanaFileToJSON(value["results"]),
  };
}
